export function user(state) {
  return state.termofservice;
}
